import { providerAccountsNavigationSelector } from "./providerAccountsNavigationSelector";
import { kubernetesClustersNavigationSelector } from "./kubernetesClustersNavigationSelector";
import { RootState } from "../../../store";

export const allAccountsNavigationSelector = (state: RootState) => {
  const providerAccounts = providerAccountsNavigationSelector(state) ?? [];
  const clusters = kubernetesClustersNavigationSelector(state) ?? [];

  return [...providerAccounts, ...clusters];
};
